import { Registry } from '@react-registry'

export const tableHeadDeserializer = (el) => {
    return {
        type: 'th',
        attrs: {}
    }
}

Registry.register(tableHeadDeserializer, { id: 'table-cell-heading', registry: 'deserializer' })